import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Mail } from "lucide-react";
import { toast } from "sonner";

export default function EmailPrefsToggle() {
  const { user, refreshUser } = useAuth();
  const [enabled, setEnabled] = useState(user?.engagement_emails_enabled !== false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { setEnabled(user?.engagement_emails_enabled !== false); }, [user]);

  const onToggle = async (checked) => {
    setBusy(true);
    try {
      await api.put("/me/email-preferences", { engagement_emails_enabled: checked });
      setEnabled(checked);
      try { await refreshUser(); } catch {}
      toast.success(checked ? "Email promozionali attivate" : "Email promozionali disattivate");
    } catch {
      toast.error("Impossibile aggiornare la preferenza");
    } finally { setBusy(false); }
  };

  return (
    <Card className="p-4 mb-6" data-testid="email-prefs-toggle">
      <div className="flex items-start justify-between gap-4">
        <div className="flex gap-3 min-w-0">
          <span className="h-9 w-9 rounded-xl bg-primary/10 grid place-items-center shrink-0"><Mail className="h-5 w-5 text-primary" /></span>
          <div className="min-w-0">
            <div className="font-semibold text-sm">Email promozionali e feedback</div>
            <p className="text-sm text-muted-foreground mt-0.5">
              Ricevi la nostra email settimanale (consigli, novità Premium o richiesta di feedback). Puoi disattivarla quando vuoi.
            </p>
          </div>
        </div>
        <Switch checked={enabled} disabled={busy} onCheckedChange={onToggle} data-testid="email-prefs-switch" />
      </div>
    </Card>
  );
}
